import { FC, Fragment } from 'react'
import { List, Grid, Divider, Typography } from '@mui/material'
import { TabsEnums, SlipsScreenType } from '../../../components'
import { ListItemComponent } from './ListItemComponent'
import { ItemEntryDetail } from '../../../services/slips'
import { TitleActionBarComponent } from './TitleActionBarComponent'
import { Bill } from 'src/services'

interface InItemComponentProps {
  data: ItemEntryDetail[]
  separatorHeight: number
  billId: number
  screenType: SlipsScreenType
  billType: string
  onClickViewPDF: (
    showRate: boolean | null,
    title?: string,
    challanId?: number,
    showOnlyGoodValue?: boolean
  ) => void
  checked: boolean
  selectTab?: (index: number) => void
  account?: Bill
  onItemDoubleClick?: (itemName: string) => void
  onSlipsEntriesUpdated?: () => void
}

export const InItemComponent: FC<InItemComponentProps> = ({
  data,
  separatorHeight,
  billId,
  screenType,
  billType,
  onClickViewPDF,
  checked,
  selectTab,
  account,
  onItemDoubleClick,
  onSlipsEntriesUpdated,
}) => {
  return (
    <>
      {data && data.length > 0 && (
        <>
          <Divider />
          <Grid
            id="properties_name"
            container
            spacing={0}
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              minHeight: '4vh',
              pl: 2,
              pr: 2,
              backgroundColor: '#f9f9f9',
              fontWeight: 'bold',
              position: 'sticky',
              top: 0,
              zIndex: 997,
            }}
          >
            <Grid xs={3} sx={{ pl: 4 }}>
              Item Name
            </Grid>
            <Grid xs={2}>Entry Time</Grid>
            <Grid xs={2} sx={{textAlign:'right', pr:2}}>Rate</Grid>
            <Grid xs={2}>
              <Typography fontWeight={'bold'} pl={4}>
                Quantity
              </Typography>
            </Grid>
            <Grid xs={2}>Entry Type</Grid>
            <Grid xs={1} sx={{ paddingLeft: 4 }}>
              Actions
            </Grid>
          </Grid>

          {data &&
            data.map((items, index) => {
              return (
                <>
                  {' '}
                  <Divider />
                  <TitleActionBarComponent
                    data={items}
                    onClickViewPDF={onClickViewPDF}
                    screenType={screenType}
                    billType={billType}
                    account={account}
                  />
                  <List
                    id="entries_list_items_per_date"
                    sx={{
                      width: '100%',
                      p: 0,
                      m: 0,
                    }}
                    component="div"
                    aria-labelledby="subheader"
                    key={index}
                  >
                    {items.itemEntries &&
                      items.itemEntries.map((item, i) => {
                        return (
                          <>
                            {(!checked || item.id >= 0) && (
                              <Fragment key={i}>
                                <Divider />
                                <ListItemComponent
                                  challan={items}
                                  item={item}
                                  key={i}
                                  componentName={TabsEnums.In}
                                  billId={billId}
                                  screenType={screenType}
                                  accountType={account?.accountType}
                                  onItemDoubleClick={onItemDoubleClick}
                                  onSlipsEntriesUpdated={onSlipsEntriesUpdated}
                                />
                              </Fragment>
                            )}
                          </>
                        )
                      })}
                  </List>
                </>
              )
            })}
        </>
      )}
    </>
  )
}
